import { post } from '@utils/request';
import { get } from '../utils/request';

//  聚合页get
export const getShoppingPolymerizeInfo = data => post('shop/trolley/indexList', data);

export const postTrolleyH5Json = (data, config) => post('shop/trolley/h5Json', data, config);
//  根据年级id查课程
export const getCourseListById = data => post('shop/trolley/getGoodsInfoByIndexId', data);

export const postTrolleyGetGoodsInfoByIds = data => post('shop/trolley/getGoodsInfoByIds', data);
//  获取购物车数字
export const getShoppingCount = params => get('shop/trolley/getTrolleyCount', params);
//  添加购物车
export const addShopping = (data, config) => post('shop/trolley/addTrolley', data, config);
//  联报加购
export const addShoppings = (data) => post('shop/trolley/addCombTrolley', data);
//  添加购物车，组合商品加购使用，返回购物车id
export const addTrolleyForComb = (data, config) => post('shop/trolley/addTrolleyForComb', data, config);

// 购物车列表
export const getShoppingCartList = (params) => post('shop/trolley/list', params);
// 购物车列表-有效商品
export const postTrolleyList = (params) => post('shop/trolley/list', params);
// 购物车失效产品列表
export const getShoppingCartInvalidList = (params) => post('shop/trolley/invalidList', params);
// 获取商品规格
export const getGoodsSpecil = (data) => post('shop/trolley/getSpecilList', data);
// 获取全部商品的规格
export const getAllGoodsSpecil = (data) => post('shop/trolley/getAllSpecilList', data);
// 获取购物车商品优惠
export const getGoodslDiscountInfo = ({ data, cancelToken }) => post('coupon/shopCartDisInOrder', data, cancelToken);
// 保存购物车商品规格
export const editGoodsSpecification = (data) => post('shop/trolley/edit', data);
// 删除购物车商品
export const delGoods = (data) => post('shop/trolley/remove', data);
// 清除购物车商品规格
export const clearGoodsFormat = (data) => post('shop/trolley/clear', data);
// 购物车商品下单校验
export const checkGoods = (params) => get('shop/cart/checkSubmitCartOrder', params);
// 确认下单页-赠品列表
export const selectGiftBatch = (data) => post('shop/order/selectGiftBatch', data);
// 购物车-领券购-未领劵批量处理
export const receiveCouponBatch = (params) => get('couponbuy/receiveCouponBatch', params);
// 校验领券购
export const verifyCouponBuy = (params) => get('couponbuy/verifyCouponBuy', params);
// 获取聚合页优惠券
export const getCouponBuy = (params) => get('couponPrepose/isReceiveTrolleyCoupon', params);

export const getCouponIsReceive = (params) => get('couponPrepose/isReceive', params);
// 领取聚合页优惠券
export const putCouponBuy = (data) => post('couponPrepose/getCoupons', data);

// APP一元加购
export const postTrolleyAddOnePurchaseShoppingTrolley = (data, config) => post('shop/trolley/addOnePurchaseShoppingTrolley', data, config);

// 获取购物车商品优惠
export const postCouponChopCartDisInOrder = (data) => post('coupon/shopCartDisInOrder', data);

// 批量获取赠品
export const getCourseGiftBatch = data => post('shop/order/getGiftBatchStatus', data);

// 获取服务器时间
export const getServerTime = () => get('goods/getTime');

// 获取618凑单信息
export const getActivityPieceTogether = (data) => post('coupon/activity/piece/together', data);

// 批量推荐位商品
export const postTrolleyLocation = data => post('shop/trolley/location', data);
// 批量推荐位商品v2
export const postTrolleyLocationV2 = data => post('shop/trolley/location/v2', data);

// 获取双十一文案
export const postDouble11 = data => post('coupon/activity/trolley/get', data);

/**
 * 校验是否符合小货架活动身份
 * activityId: 活动id
 */
export const trolleyCheckUserInfo = params => get('shop/trolley/checkUserInfo', params);

/**
 * 推荐列表
 */
export const postRecommendList = data => post('coupon/recommend/list', data);

/**
 * 购物车 和 邮寄单浮窗
 * bizType  SHOP_CART 购物车浮窗    MAIL_ORDER 邮寄单浮窗
 */
export const getShopFloat = params => get('shop/float/get', params);


// @aigc:start 2024/06/18-14:40
// 批量获取商品优惠信息
export const postGoodsDiscountInfo = data => post('goods/goodsInfoByIds', data);
// 获取组合购优惠信息
export const postCombGoodsDiscountInfo = data => post('shop/trolley/trolleyAgg', data);
// @aigc:end 2024/06/18-14:40

